// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.


import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getIsShareEntity } from "@insite/client-framework/ServerSideRendering";
import { Session } from "@insite/client-framework/Services/SessionService";
import { SettingsModel } from "@insite/client-framework/Services/SettingsService";
import { chain, LookUpData } from "@insite/client-framework/Store/CommonHandlers/SetOdpTracking";

type HandlerType = Handler<{}, { session: Session; settings: SettingsModel }>;

export const XngLookUpData: HandlerType = props => {
    const state = props.getState();

    /* XNG-Change: add !state.context.settings.settingsCollection.websiteSettings.enableOdpStorefrontEvents to prevent console error
    (this will be part of next upgrade) 
    */
    if (
        IS_SERVER_SIDE ||
        !state.context.settings.settingsCollection.websiteSettings.enableOdpStorefrontEvents ||
        getIsShareEntity()
    ) {
        return false;
    }

    props.session = state.context.session;
    props.settings = state.context.settings;
};

replaceInChain(chain, LookUpData, XngLookUpData);
